import { usePlatformStore } from "@/store/platform/platform";

class ModuleManager {
  moduleIsAvailable(item) {
    return ![
      "MODULE_STUDEA_TRIAD_DECLARE_CONTRACT_RUPTURE",
      "MODULE_STUDEA_REGISTRATION",
      "MODULE_STUDEA_GENERAL",
      "MODULE_STUDEA_QUESTIONNAIRE",
      "MODULE_STUDEA_CONTROL",
      "MODULE_EMAILS",
      "MODULE_YPAREO",
      "MODULE_AMMON",
      "MODULE_UNISERVICE",
      "MODULE_EDUSIGN",
      "MODULE_AMMON",
      "MODULE_UNISERVICE",
      "MODULE_STUDEA_NOTE",
      "MODULE_STUDEA_TRIAD_DECLARE_CONTRACT_RUPTURE",
      "MODULE_STUDEA_MISSIONS_ACTIVITIES",
    ].includes(item.code);
  }
  isModuleActive(moduleCode, platformStore = usePlatformStore()) {
    return platformStore.modulesAvailable.some((module) => module.code === moduleCode);
  }
}

export const moduleManager = new ModuleManager();
